// Module-level singleton, so it survives an AsyncPaginatedSelect instance
// being destroyed and recreated by vue-router (no <keep-alive> wraps
// <router-view> in this app, so every navigation tears down route components).
const cache = {};

// Returns the mutable per-scope cache object for a given cache id, creating
// it on first use. Callers with no cacheId get a fresh object each time, i.e.
// no cross-mount persistence (matches the prior always-local-state behavior).
export function getScopeCache(cacheId) {
	if (!cacheId) return {};
	return (cache[cacheId] = cache[cacheId] || {});
}

// Lets callers explicitly invalidate a cached dropdown's loaded pages, e.g.
// after creating a record that should now appear in its own options list.
export function clearAsyncSelectCache(cacheId) {
	delete cache[cacheId];
}
